import {
  LeadingImageImagesData,
  ProductImage,
} from "../store/leading-image/LeadingImageTypes";
import { ImageListItem, styled } from "@mui/material";

interface Props {
  imageList: LeadingImageImagesData[];
  handleImageClick: (image: ProductImage) => void;
  leadingImage: string | null;
  disabled?: boolean;
}

const ImageListItems = (props: Props) => {
  const { imageList, handleImageClick, leadingImage, disabled } = props;

  const imageListClasses = {
    imageCard: "imageCard",
    leadingImageCard: "leadingImageCard",
  };

  const StyledImageListItem = styled(ImageListItem)(({ theme }) => ({
    [`&.${imageListClasses.imageCard}`]: {
      "&:hover": {
        border: "2px solid " + theme.palette.error.main,
        cursor: "pointer",
      },
    },
    [`&.${imageListClasses.leadingImageCard}`]: {
      "&:hover": {
        cursor: "pointer",
      },
    },
  }));

  const imageClasses = {
    image: "image",
  };

  const StyledImage = styled("img")(() => ({
    [`&.${imageClasses.image}`]: {
      width: "100%",
      height: "100%",
      objectFit: "inherit",
    },
  }));

  if (!Object.keys(imageList)?.length) {
    return <></>;
  }
  return (
    <>
      {imageList?.length ? (
        imageList.map((image, index) => {
          return (
            <StyledImageListItem
              key={index}
              sx={{
                border: `medium solid ${leadingImage === image.imageId ? "red" : "white"}`,
              }}
              onClick={
                disabled
                  ? undefined
                  : () => {
                      handleImageClick(image);
                    }
              }
              className={
                disabled
                  ? undefined
                  : leadingImage !== image.imageId && !image.isSelected
                    ? imageListClasses.imageCard
                    : imageListClasses.leadingImageCard
              }
            >
              <StyledImage
                src={`${image.url}`}
                alt={image.imageId}
                className={imageClasses.image}
              />
            </StyledImageListItem>
          );
        })
      ) : (
        <></>
      )}
    </>
  );
};

export default ImageListItems;
